import { useQuery } from "@tanstack/react-query"
import { ModernCard, ModernCardHeader, ModernCardContent } from "@/components/ui/modern-card"
import { Button } from "@/components/ui/button"

export default function FamilyPage() {
  const { data } = useQuery<{ families: Array<{ doorNumber: string; section: string; district: string; members: number }> }>({
    queryKey: ["/api/family"],
  })

  return (
    <div className="min-h-screen p-4">
      <ModernCard>
        <ModernCardHeader>
          <span>Families</span>
        </ModernCardHeader>
        <ModernCardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {data?.families?.map((f, i) => (
              <div key={`${f.doorNumber}-${f.section}-${i}`} className="border rounded-xl p-4">
                <div className="font-medium">{f.doorNumber}</div>
                <div className="text-sm text-gray-500">{f.section} • {f.district}</div>
                <div className="mt-2 text-sm">Members: {f.members}</div>
                <Button
                  variant="outline"
                  size="sm"
                  className="mt-3"
                  onClick={async () => {
                    const params = new URLSearchParams({ doorNumber: f.doorNumber, section: f.section, district: f.district })
                    const res = await fetch(`/api/family/members?${params.toString()}`)
                    if (res.ok) {
                      const json = await res.json()
                      alert(`Members for ${f.doorNumber}:\n` + json.members.map((m: any) => m.name).join("\n"))
                    }
                  }}
                  data-testid={`family-view-${i}`}
                >View Members</Button>
              </div>
            ))}
          </div>
        </ModernCardContent>
      </ModernCard>
    </div>
  )
}

